import React, { useState, useContext, useEffect, useReducer, useRef } from 'react';
import "../../site.css";
import { AuthContext } from "../../AuthContext";
import * as FaIcons from 'react-icons/fa';
import * as BsIcons from "react-icons/bs";
import * as RiIcons from "react-icons/ri";
import { Button, Modal } from 'react-bootstrap';
import { Envelope, EnvelopeFill, Phone, Telephone } from 'react-bootstrap-icons';
import { getToken, saveToken } from '../Hooks/Token';
import moment from "moment";
import { getAPI } from '../GdacsAPI';
import { useViewPort } from '../Hooks/useViewPort';
import ReCAPTCHA from 'react-google-recaptcha';
import { ValidateNumber } from './ValidateNumber';
import { ValidateWidget } from './ValidateWidget';

const ValidateContainer = (props) => {
    const authContext = React.useContext(AuthContext);
    const [addresses, setAddresses] = React.useState(authContext.data?.addresses.map((a, i) => ({ ...a, id: i })) ?? []);
    const [editingAddressId, setEditingAddressId] = React.useState();
    const [responseMessage, setResponseMessage] = React.useState("");
    const [userData, setUserData] = React.useState(authContext.data);
    const { width } = useViewPort();
    const breakpoint = 520;


    const handleChangeAddress = (addresses) => {
        props.onChange("addresses", addresses);

    }

    const handleChangeButton = (isButtonDisabled) => {
        props.isButtonDisabled(isButtonDisabled);
    }

    React.useEffect(() => {

    }, [addresses]);

    return (width < breakpoint ? <div>
        <ValidateWidget params={ props.params} />
    </div>
        :
        <div>
            <ValidateNumber params={props.params} onChange={handleChangeAddress} />
    </div>)
}
export { ValidateContainer };